import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Box, ButtonDropdown, Container, Grid, Header, KeyValuePairs, SpaceBetween, Spinner, Tabs } from "@amzn/awsui-components-react";
const EmbedFlexicoParams = (props) => {
  const [params, setParams] = useState([])
  
  useEffect(() => {
    if(props?.transactionInfo && props?.flexicoTemplateInfo){
      processFlexicoParams(props.transactionInfo, props.flexicoTemplateInfo)
    }
  }, [props?.transactionInfo, props?.flexicoTemplateInfo])

  // `parameters` is the legacy blob and prefixes every key with '--' (see
  // Cruzer/EventBridgeOrchestratorHandler); `plainParameters` uses bare keys. Strip the prefix so
  // an older transaction still joins against the template's labels.
  function parseParameters(transactionInfo){
    // A bare `JSON.parse(a) || JSON.parse(b)` throws on a missing `a` before the fallback is ever
    // reached, which is why transactions written without plainParameters rendered nothing.
    for (const raw of [transactionInfo.plainParameters, transactionInfo.parameters]) {
      if (!raw) continue
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (parsed && typeof parsed === 'object') {
          return Object.keys(parsed).reduce((acc, key) => {
            acc[key.startsWith('--') ? key.slice(2) : key] = parsed[key]
            return acc
          }, {})
        }
      } catch (e) {
        console.error('EmbedFlexicoParams: could not parse transaction parameters', e)
      }
    }
    return null
  }

  function processFlexicoParams(transactionInfo, flexicoTemplateInfo){
    const labelObject = (flexicoTemplateInfo.parameters || []).reduce((acc, param) => {
      acc[param.label] = param;
      return acc;
    }, {});
    const parameters = parseParameters(transactionInfo)
    if(parameters){
      let paramObject = []
      Object.keys(parameters).forEach((key) => {
        if (labelObject[key] && !labelObject[key].is_hidden) {
          paramObject.push({
            // display_name is a LEFT JOIN on flexico_parameters and can come back null; the label
            // is what the uploader actually saw, so fall back to it rather than rendering blank.
            'label': labelObject[key].display_name || key,
            'value': parameters[key]
          })
        }
      })
      setParams(paramObject)
    }
  }

  return (<Container
    header={<Header
      variant="h3"
      description="Parameters chosen while execution"
    >
      Input
    </Header>} >
    <KeyValuePairs
      columns={3}
      items={params}
    />
  </Container>)

}

export default EmbedFlexicoParams;
